export default function () {
  if (typeof window !== 'undefined' && typeof window.navigator !== 'undefined') {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
  }

  console.error('window is not defined! 请在 useEffect 中使用该函数进行判断');
  return false;
}

export const getIsMobile = function (userAgent) {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|OpenHarmony|HarmonyOS/i.test(userAgent || '');
};
